import { render, staticRenderFns } from "./cameraForm.pug?vue&type=template&id=45a547fc&lang=pug&external"
import script from "./cameraForm.js?vue&type=script&lang=js&external"
export * from "./cameraForm.js?vue&type=script&lang=js&external"
import style0 from "./cameraForm.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a547fc')) {
      api.createRecord('45a547fc', component.options)
    } else {
      api.reload('45a547fc', component.options)
    }
    module.hot.accept("./cameraForm.pug?vue&type=template&id=45a547fc&lang=pug&external", function () {
      api.rerender('45a547fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/multidamageList/components/cameraForm/index.vue"
export default component.exports